////////////////////////////////////// Googlesuche


var gcsResultChecker;

function initGCS(){

    /////// Googlesuche
    gcsResultChecker=0;

    reposSearchBoxWrapper();

    $('#searchBoxWrapper').html('<gcse:searchbox></gcse:searchbox>');
    $('#searchResultWrapper .newWidth1600').html('<gcse:searchresults></gcse:searchresults>');

    setTimeout(function(){
        (function() {
            var cx = '4a62ea880fe90b715';
            var gcse = document.createElement('script');
            gcse.type = 'text/javascript';
            gcse.async = true;
            gcse.src = 'https://cse.google.com/cse.js?cx=' + cx;
            var s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(gcse, s);
        })();
        showGCSResults(false);

        $('#searchBoxWrapper').click(function(){
            gcsResultChecker = setInterval(function(){
                // if($(".gsc-results-wrapper-nooverlay").hasClass('gsc-results-wrapper-visible')){
                //     if ( $('.mainMenueWrapper').hasClass('menueOpened') == false) toggleMenu();
                    clearInterval(gcsResultChecker);
                    showGCSResults();
                // }
            },333);
        });
    },700);

}



function showGCSResults(_arg){
    //console.log("int id: "+gcsResultChecker);
    //for(var q=0;q<=500;q++) clearInterval(q);
    clearInterval(gcsResultChecker);
    if(_arg==undefined || _arg==true){
        $('#searchResultWrapper').show();
    }else{
        $('#searchResultWrapper').hide();
    }
}

function reposSearchBoxWrapper(){
    //console.log("searchBoxWrapper: "+$('#searchBoxWrapper').parent().attr('id'));
    // if(isSmartPhone){
    //     if($('#searchBoxWrapper').parent().attr('id')=="mainmenu") $('#searchBoxWrapper').appendTo('.mainMenueWrapper');
    // }else{
    //     if($('#searchBoxWrapper').parent().hasClass('mainMenueWrapper')) $('#searchBoxWrapper').appendTo('#mainmenu');
    // }

}

